import { AbstractControl, ValidatorFn } from '@angular/forms';

export const isNumber: ValidatorFn = (control: AbstractControl) => {
  const num: boolean = !isNaN(Number.parseFloat(control.value));

  return num ? null : {isNumber: false};
};
